<template>
	<div class="attorney_judge sub_panel">
		<section-title v-on:toggleExpansion="toggleExpansion" title="Attorney / Judge" :is-expanded="is_expanded"></section-title>
		<el-collapse-transition>
			<div class="panel_detail" v-if="is_expanded">
				<el-form-item label="DEFENDING ATTORNEY" prop="attorney_judge.defending_attorney" :rules="validation.defending_attorney">
					<el-input type="text" v-model="defending_attorney" :maxlength="input_max" clearable></el-input>
				</el-form-item>
				<!-- <el-form-item label="PROSECUTING ATTORNEY" prop="attorney_judge.prosecuting_attorney" :rules="validation.prosecuting_attorney">
					<el-input type="text" v-model="prosecuting_attorney" :maxlength="input_max" clearable></el-input>
				</el-form-item> -->
				<el-form-item label="JUDGE" prop="attorney_judge.judge" :rules="validation.judge">
					<el-input type="text" v-model="judge" :maxlength="input_max" clearable></el-input>
				</el-form-item>
			</div>
		</el-collapse-transition>
	</div>
</template>

<script>
import panel_mixin from './panel-mixin.js';
import sectionTitle from './Section-Title.vue';
import { mapState } from 'vuex';
import { mapFields } from 'vuex-map-fields';
export default{
	mixins: [panel_mixin],
	components: {
		sectionTitle
	},
	computed: {
		...mapState(['input_max']),
		...mapFields('attorney_judge', ['is_expanded', /* 'prosecuting_attorney', */ 'defending_attorney', 'judge']),
		...mapFields('defendant', ['first_name', 'last_name'])
	},
	data(){
		return{
			validation: {
				judge: [
					{ min: 3, message: "Should at least be three characters", trigger: "blur"},
					// { validator: this.requirementValidation, trigger: "blur" }
				],
				// prosecuting_attorney: [
				// 	{ min: 3, message: "Should at least be three characters", trigger: "blur"},
				// 	// { validator: this.requirementValidation, trigger: "blur" }
				// ],
				defending_attorney: [
					{ min: 3, message: "Should at least be three characters", trigger: "blur"},
					// { validator: this.requirementValidation, trigger: "blur" }
				]
			}
		}
	},
	methods: {
		// requirementValidation(rule, value, callback){
		// 	if((!this.first_name || !this.last_name) && !this.judge){ callback(new Error('Must search by defendant or judge'))}
		// 	else{callback()}
		// }
	}
}
</script>
